export default __webpack_public_path__ + "static/media/search.80704823.svg";